import request from '../utils/http'
// 首页统计
export function statistics (query) {
  return request({
    url: '/statistics/list',
    method: 'GET',
    params: query
  })
}
// 机构列表
export function mechanismList (query) {
  return request({
    url: '/mechanism/list?limit=500',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js